import { render } from "./BusinessClientCoupons.vue?vue&type=template&id=99cc9378&scoped=true&ts=true"
import script from "./BusinessClientCoupons.vue?vue&type=script&lang=ts"
export * from "./BusinessClientCoupons.vue?vue&type=script&lang=ts"

import "./BusinessClientCoupons.vue?vue&type=style&index=0&id=99cc9378&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99cc9378"]])

export default __exports__